import React from 'react';

function ProfileHeader({ name, title }) {
  return (
    <div className="profile-header">
      <h1>{name}</h1>
      <h2>{title}</h2>
    </div>
  );
}

export default ProfileHeader;